// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserContact_wrapper__3w2Xd","avatar":"UserContact_avatar__k-Ol9","assignName":"UserContact_assignName__3M3Tt"};